import React, { useLayoutEffect, useRef, useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import TemplateSite from './TemplateSite';

// The site's layout follows the viewport breakpoints, so on small screens it is
// laid out at phone width to keep the preview matching what the layout shows.
const DESKTOP_WIDTH = 1280;
const MOBILE_WIDTH = 420;

// A live, scaled-down render of a template used as its thumbnail, scaled to
// fit so the preview always matches the real demo page.
const TemplatePreview = ({ template, ratio = 0.72, scroll = false }) => {
  const theme = useTheme();
  const siteWidth = useMediaQuery(theme.breakpoints.down('md')) ? MOBILE_WIDTH : DESKTOP_WIDTH;
  const ref = useRef(null);
  const [scale, setScale] = useState(0.25);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const update = () => setScale(el.clientWidth / siteWidth || 0.25);
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, [siteWidth]);

  return (
    <Box ref={ref} aria-hidden inert sx={{
      position: 'relative', width: '100%', paddingTop: `${ratio * 100}%`, overflow: 'hidden',
      bgcolor: template.colors.bg, pointerEvents: 'none', userSelect: 'none',
    }}>
      <Box className="template-preview-site" sx={{
        position: 'absolute', top: 0, left: 0, width: siteWidth,
        // Cards set --tpl-scroll on hover to glide down the page, Phlox style.
        transform: `scale(${scale}) translateY(var(--tpl-scroll, 0%))`, transformOrigin: 'top left',
        transition: scroll ? 'transform 4s ease-in-out' : 'none',
      }}>
        <TemplateSite template={template} preview />
      </Box>
    </Box>
  );
};

export default TemplatePreview;
